import React from 'react';
import { Props } from './types';
import { Container } from './styles';
import Card from './Card';
import { colorBackground } from '../../../Utils';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { Skeleton } from 'antd';
import Reabrir from '../../../Modal/Reabrir';

const RigthContainer: React.FC<Props> = () => {
  const ocorrencia = useSelector((state: ApplicationState) => state.Ocorrencia?.data['ocorrencia']);
  const loading = useSelector((state: ApplicationState) => state.Ocorrencia.loading);
  const urgencia = useSelector(
    (state: ApplicationState) => state.Ocorrencia?.data['ocorrencia']?.urgencia
  );
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil);
  const showInfo = perfil && ['A', 'ANCD'].includes(perfil);

  const color = colorBackground(urgencia);
  return !loading ? (
    <Container style={{ backgroundColor: color }}>
      <Card />
      <div style={{ width: '100%' }}>{!showInfo && <Reabrir propriedades={ocorrencia} />}</div>
    </Container>
  ) : (
    <Container>
      <Skeleton active />
      <Skeleton active />
      <Skeleton active />
      <Skeleton active />
      <Skeleton active />
    </Container>
  );
};

export default RigthContainer;
